import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function locationsPunch(latitude, longitude) {
    let url = 'punch/locations?' + objectToQueryString({ company: Company(), userCode: UserCode(), token: Token(), latitude: latitude, longitude: longitude });
    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let locations = response.locations;

                //saveLocations(locations);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortLocation(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.DescriptionE.toLowerCase() : a.DescriptionF.toLowerCase()
        const nameB = IsEnglish() ? b.DescriptionE.toLowerCase() : b.DescriptionF.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortLocationByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.GeolocationCode
        const nameB = b.GeolocationCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

function saveLocations(config) {
    localStorage.setItem('punchLocations', JSON.stringify(config));
}